import CommandObject from "./CommandObject";

export default class ReorderFramesCommandObject extends CommandObject {
  constructor(undoHandler, data) {
    super(undoHandler, true);
    this.oldValue = data.oldData;
    this.newValue = data.newData;
  }

  toString() {
    return ["Move", this.targetObject.type, "frame"].join(' ')
  }

  /* override to return true if this command can be executed,
   *  e.g., if there is an object selected
   */
  canExecute() {
    let frames = this.getUndoHandler.getState().frames
    let framesMap = this.getUndoHandler.getState().framesMap
    return frames.filter(
      (id) => (id) => framesMap[id] ? framesMap[id].visible : false
    ).length > 0
  }

  /* override to execute the action of this command.
   * pass in false for addToUndoStack if this is a command which is NOT
   * put on the undo stack, like Copy, or a change of selection or Save
   */
  execute() {
    // Note that this command object must be a NEW command object so it can be
    // registered to put it onto the stack
    if (this.addToUndoStack) this.undoHandler.registerExecution(this);
  }

  /* override to undo the operation of this command
   */
  undo() {
    this.undoHandler.reorderFramesArr(this.newValue, this.oldValue);
  }

  /* override to redo the operation of this command, which means to
   * undo the undo. This should ONLY be called if the immediate
   * previous operation was an Undo of this command. Anything that
   * can be undone can be redone, so there is no need for a canRedo.
   */
  redo() {
    this.undoHandler.reorderFramesArr(this.oldValue, this.newValue);
  }

  /* override to return true if this operation can be repeated in the
   * current context
   */
  canRepeat() {}

  /* override to execute the operation again, this time possibly on
   * a new object. Thus, this typically uses the same value but a new
   * selectedObject.
   */
  repeat() {}
}
